<label [ngClass]="['ui-checkbox', 'mb-0', 'ui-checkbox-' + size]"
       [class.ui-checkbox-disabled]="disabled">
  <i class="icon"
     [class.icon-checkbox-marked]="model"
     [class.icon-checkbox-blank-outline]="!model"></i>
  <input type="checkbox"
         [disabled]="disabled"
         [checked]="model"
         (change)="onChange($event)">
  <ng-content></ng-content>
</label>
